export default {
  collections: {},
  documents: {},
  versions: {},
  requestedCollections: {},
}
